export default __webpack_public_path__ + "static/media/mic_on.984219bb.svg";